export enum CookieConsentTexts {
    MESSAGE = "На нашем сайте мы используем cookie файлы.",
    LINK = "Узнать подробнее",
    APPROVE = "Хорошо"
}